import {
  FETCH_COOLDOWN_TASKS_REQUEST,
  FETCH_COOLDOWN_TASKS_SUCCESS,
  FETCH_COOLDOWN_TASKS_FAILURE,
  FETCH_COOLDOWN_TASK_DETAIL_REQUEST,
  FETCH_COOLDOWN_TASK_DETAIL_SUCCESS,
  FETCH_COOLDOWN_TASK_DETAIL_FAILURE,
  CLEAR_COOLDOWN_TASK_DETAIL,
} from './cooldownTaskTypes';

const initialState = {
  loading: false,
  cooldownTasks: [],
  error: '',
  // The single row behind the edit popup. Kept in this slice rather than reusing
  // getTemplateAutoTaskBasedOnAutoTaskId so the cooldown and Thermit single measure
  // edit dialogs never overwrite each other's row.
  detailLoading: false,
  cooldownTaskDetail: null,
};

const cooldownTaskReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_COOLDOWN_TASKS_REQUEST:
      return { ...state, loading: true };
    // Spread rather than rebuild: a list refresh must not drop the row the edit
    // popup is currently bound to, and every save refreshes the list.
    case FETCH_COOLDOWN_TASKS_SUCCESS:
      return { ...state, loading: false, cooldownTasks: action.payload, error: '' };
    case FETCH_COOLDOWN_TASKS_FAILURE:
      return { ...state, loading: false, cooldownTasks: [], error: action.payload };

    case FETCH_COOLDOWN_TASK_DETAIL_REQUEST:
      return { ...state, detailLoading: true, cooldownTaskDetail: null };
    case FETCH_COOLDOWN_TASK_DETAIL_SUCCESS:
      return { ...state, detailLoading: false, cooldownTaskDetail: action.payload };
    case FETCH_COOLDOWN_TASK_DETAIL_FAILURE:
      return { ...state, detailLoading: false, cooldownTaskDetail: null, error: action.payload };
    case CLEAR_COOLDOWN_TASK_DETAIL:
      return { ...state, detailLoading: false, cooldownTaskDetail: null };

    default:
      return state;
  }
};

export default cooldownTaskReducer;
